<ds-layout  style="overflow: hidden">
  <ds-layout-header>
    <page-header (collapseStateChange)="setCollapseState()"></page-header>
  </ds-layout-header>
  <ds-layout-subheader>
    <section class="subheader-content">
      <ds-breadcrumb></ds-breadcrumb>
      <ng-container dsAddTarget="pageHeaderTitle">
      </ng-container>
    </section>
  </ds-layout-subheader>
  <ds-layout-sidebar [collapsed]="isSidebarCollapsed"
                     [ngStyle]="{'visibility': isSidebarCollapsed ? 'hidden' : 'visible'}"
                     tabindex="0">
    <div>
      <ds-menu (click)="setCollapseState()" [collapsed]="isSidebarCollapsed" [items]="menuItems"></ds-menu>
    </div>
  </ds-layout-sidebar>
  <ds-layout-content>
    <router-outlet></router-outlet>
  </ds-layout-content>
  <ds-layout-footer>
    <page-footer></page-footer>
  </ds-layout-footer>
</ds-layout>

<app-http-error-modal></app-http-error-modal>
